const BABY = {
    name: `Suivi des repas de bébé`,
    description: `Un outil pour se souvenir de ce que bébé à mangé, en quelle quantité et s'il a aimé.`,
    technologies: ['HTML', 'CSS', 'React', 'Redux', 'MaterialUI', 'Firebase'],
    firstReleaseDate: '10/09/2020'
};

export default BABY;
